<template>
  <div>
    <!--
        action: 上传图片的地址
        list-type：展示类型
        limit 上传个数限制
        auto-upload 选取文件后就上传 开启
        file-list 文件列表
        on-exceed  超出上传限制时的行为
        on-change 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
        before-upload 限制用户上传的图片格式和大小。 若返回 false 或者返回 Promise 且 reject，则停止上传
        before-upload 限制用户上传的图片格式和大小。
        name: 图片上传后台需要的name  文件名
        headers: 请求头
        data：上传时附带的额外参数
        multiple
        硬编码：
        on-preview：点击文件列表中已上传的文件时的钩子
        -->
    <el-upload
      action="https://upload.qiniup.com"
      name="file"
      :limit="limit"
      :file-list="fileList"
      :data="qnData"
      list-type="picture-card"
      :class="{ hide: hideUpload }"
      :on-error="handleError"
      :on-exceed="handleExceed"
      :on-change="handleEditChange"
      :on-success="handleSucces"
      :before-upload="handleBefore"
      :accept="typeList.map((u) => '.' + u).join(',')"
    >
      <!-- 上传按钮 -->
      <i slot="default" class="el-icon-plus"></i>
      <div  class="el-upload__tip" slot="tip">
        *只能上传"{{ typeList.join("/") }}"文件，且不超过{{
          fileLimit
        }}M<br/>*仅支持上传多张图片，其他文件类型仅能上传单个文件
      </div>
      <div slot="file" slot-scope="{ file }">
        <!-- {{ file }} -->
        <label class="el-upload-list__item-status-label"
          ><i class="el-icon-upload-success el-icon-check"></i
        ></label>
        <img
          v-if="
            ['png', 'jpeg', 'jpg'].indexOf(
              file.url.replace(/.+\./, '').toLowerCase()
            ) != -1
          "
          class="el-upload-list__item-thumbnail"
          :src="file.url"
        />
        <video
          v-if="
            ['avi', 'rm', 'rmvb', 'mp4'].indexOf(
              file.url.replace(/.+\./, '').toLowerCase()
            ) != -1
          "
          class="el-upload-list__item-thumbnail"
          :src="file.url"
        ></video>
        <img
          v-if="
            ['pdf', 'doc', 'docx'].indexOf(
              file.url.replace(/.+\./, '').toLowerCase()
            ) !== -1
          "
          class="el-upload-list__item-thumbnail"
          src="../assets/upload/wp.png"
        />

        <span class="el-upload-list__item-actions">
          <!-- 查看按钮 -->
          <span
            v-if="
              ['png', 'jpeg', 'jpg'].indexOf(
                file.url.replace(/.+\./, '').toLowerCase()
              ) != -1
            "
            class="el-upload-list__item-preview"
            @click="handlePreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <!-- 查看按钮 -->
          <span
            v-if="
              ['avi', 'rm', 'rmvb', 'mp4'].indexOf(
                file.url.replace(/.+\./, '').toLowerCase()
              ) != -1
            "
            class="el-upload-list__item-preview"
            @click="handlePreview2(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <!-- 删除按钮 -->
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <!-- 预览弹框 -->
    <!-- :append-to-body="true" 解决遮罩层 覆盖内容的问题 -->
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="" />
      <!-- <viewer :images="fileList" style="height: 800px">
        <img
          v-for="item in fileList"
          :src="item.src"
          :key="item.src"
          height="100"
        />
      </viewer> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // fileUrl: "",
    fileList: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    allowType: {
      required: false,
      type: Number,
      default: 0, //0 全部 ，1 图片 ，2 文档
    },
    limit: {
      required: false,
      type: Number,
      default: 1, //限制个数
    },
    fileLimit: "", //限制大小
  },
  data() {
    return {
      // 上传按钮隐藏
      hideUpload: false,
      //用于图片回显，，新增成功并增加
      // fileList: [],
      //新增删除都从这里 取值
      // fileList: [],
      qnData: {
        token: "",
        key: "",
      },
      // domainUrl: "",
      // limited: 1,
      // limit: 1, //限制上传个数
      dialogImageUrl: "", //预览图片 路径
      dialogVisible: false, // 预览框显示
      //当前文件的类型，用于图片回显
      cutFileType: 1, // 1图片 2文档
    };
  },
  computed: {
    typeList: function () {
      if (this.allowType === 0) {
        return [
          "png",
          "jpeg",
          "jpg",
          "pdf",
          "doc",
          "docx",
          // "avi",
          // "rm",
          // "rmvb",
          // "mp4",
        ];
      } else if (this.allowType === 1) {
        return ["png", "jpeg", "jpg"];
      } else if (this.allowType === 2) {
        return ["avi", "rm", "rmvb", "mp4", "png", "jpeg", "jpg"];
      }
    },
  },
  created() {
    // if (this.fileList.length > 0) {
    //   this.fileList = this.fileList;
    // }
    // if (this.fileUrl) {
    //   let fileSuffix = this.fileUrl.replace(/.+\./, "");
    //   if (["png", "jpeg", "jpg"].indexOf(fileSuffix.toLowerCase()) != -1) {
    //     this.cutFileType = 1;
    //   } else {
    //     this.cutFileType = 2;
    //   }
    // }
    // if (this.fileUrl) {
    //   this.fileList = [
    //     {
    //       name: this.fileUrl.split("/")[this.fileUrl.split("/").length - 1],
    //       url: this.fileUrl,
    //     },
    //   ];
    // } else {
    //   this.fileList = [];
    // }
    // if (this.fileList.length > 0) {
    //   this.fileList.push(this.fileList[0]);
    // }
    this.hideUpload = this.fileList.length >= this.limit;
  },

  methods: {
    handleBefore(file) {
      //后缀名类型判断
      let FileExt = file.name.replace(/.+\./, "");

      //当前文档类型
      if (["pdf", "doc", "docx"].indexOf(FileExt.toLowerCase()) != -1) {
        // this.cutFileType = 2;
        this.limit = 1;
      } else if (
        ["avi", "rm", "rmvb", "mp4"].indexOf(FileExt.toLowerCase()) != -1
      ) {
        this.limit = 1;
        // this.cutFileType = 2;
      } else {
        // this.cutFileType = 1;
      }

      if (this.typeList.indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为" + this.typeList.join(",") + "的附件！",
        });
        return false;
      }
      //文件大小判断
      if (file.size / 1024 / 1024 > this.fileLimit) {
        this.$message.error("上传文件大小必须小于" + this.fileLimit + "MB");
        return false;
      }
      //获取token，文件上传
      return this.$axios
        .get("/file/getQiNiuAccessToken")
        .then((res) => {
          this.qnData.token = res.data.accessToken;
          this.qnData.key =
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1]; // 处理上传同名文件失败加上时间戳
          this.domainUrl = res.data.domainUrl;
        })
        .catch((err) => {
          this.$message({ type: "error", message: err });
        });
    },
    //上传成功
    handleSucces(response, file, fileList) {
      // console.log("file", file);
      // console.log("fileList", fileList);
      //给fileList添加会出现bug
      this.fileList.push({
        name: file.raw.name,
        url: this.domainUrl + response.key,
        uid: file.uid,
        type: file.raw.type,
        size: file.raw.size,
      });
      if (!file.raw.type.includes("image")) {
        this.$emit("uploadFileUrl", this.domainUrl + response.key, [
          {
            name: file.raw.name,
            url: this.domainUrl + response.key,
            uid: file.uid,
            type: file.raw.type,
            size: file.raw.size,
          },
        ]);
      } else {
        this.$emit(
          "uploadFileUrl",
          this.domainUrl + response.key,
          this.fileList
        );
      }
      //判断上传文件的类型，用于回显
      // console.log(this.fileList);
      // debugger;
    },
    //失败
    handleError() {
      this.$message.warning("上传失败请稍后重试！");
    },
    // 超出限制个数的提示
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // 移除按钮
    handleRemove(file) {
      //file ===后面新增的file ，，name是原来的name，不是时间戳，并且有response属性 key即时间戳name
      //file ===本来就存在的file ，，name是原来的时间戳
      //所以fileList需要过滤两次
      console.log("移除--file", file);
      // debugger;
      // this.fileList = this.fileList.filter((item) => item.uid != file.uid);
      this.fileList = this.fileList.filter((item) => item.uid != file.uid);
      // this.fileList = this.fileList.filter(
      //   (item) => item.name != file.response.key
      // );
      // debugger;
      // console.log(this.fileList);
      // console.log(file);
      this.hideUpload = this.fileList.length >= this.limit;
      this.$emit("uploadFileUrl", "", this.fileList);
    },
    // 预览
    handlePreview(file) {
      // console.log("点击文件列表中已上传的文件时的钩子 放大 预览");
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePreview2(file) {
      window.open(file.url, "_blank");
    },
    handleEditChange(file, fileList) {
      // console.log("Change-----file", file);
      // console.log("Change------fileList", fileList);
      this.hideUpload = this.fileList.length >= this.limit;
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
/deep/.hide .el-upload--picture-card {
  display: none;
}
.el-upload__tip {
  line-height: 26px;
}
</style>
